/**
 * Checks if a WebP file is animated by looking for the ANIM chunk in the file header
 * @param file
 * @returns
 */
const checkWebpAnimated = async (file: File): Promise<boolean> => {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = e => {
      const arr = new Uint8Array(e.target?.result as ArrayBuffer);
      // WebP file header is "RIFF....WEBP"
      if (arr[0] !== 0x52 || arr[1] !== 0x49 || arr[2] !== 0x46 || arr[3] !== 0x46) {
        resolve(false);
        return;
      }
      if (arr[8] !== 0x57 || arr[9] !== 0x45 || arr[10] !== 0x42 || arr[11] !== 0x50) {
        resolve(false);
        return;
      }

      // Look for ANIM chunk
      for (let i = 12; i < arr.length - 4; i++) {
        if (arr[i] === 0x41 && arr[i + 1] === 0x4e && arr[i + 2] === 0x49 && arr[i + 3] === 0x4d) {
          resolve(true);
          return;
        }
      }
      resolve(false);
    };
    reader.readAsArrayBuffer(file);
  });
};

/**
 * Checks if an image file is animated
 * @param file
 * @returns
 */
export const isAnimatedImage = async (file: File) => {
  if (file.type === 'image/gif') {
    return true;
  }

  if (file.type === 'image/webp') {
    return checkWebpAnimated(file);
  }

  return false;
};
